import styled from 'styled-components'

const Wrapper = styled.div`
  width: 100%;
  overflow: hidden;
`

export default Wrapper



// WEBPACK FOOTER //
// ./src/components/shared/Carousel/Wrapper.js